// import React from 'react';
// import { motion } from 'framer-motion';

// const OqlousLogo = () => {
//   const dots = [
//     { x: 10, y: 30, r: 1.5 },
//     { x: 20, y: 22, r: 2 }, { x: 20, y: 38, r: 2 },
//     { x: 32, y: 15, r: 2.5 }, { x: 32, y: 30, r: 3.5 }, { x: 32, y: 45, r: 2.5 },
//     { x: 46, y: 8, r: 2 }, { x: 46, y: 23, r: 3 }, { x: 46, y: 37, r: 3 }, { x: 46, y: 52, r: 2 }
//   ];

//   return (
//     <div className="flex items-center p-12 space-x-0 rounded-xl">
//       <div className="relative flex items-center justify-center">
//         {/* Subtle Blueish Shadow/Glow behind the logo */}
//         {/* <div className="absolute inset-0 scale-150 rounded-full bg-blue-500/20 blur-2xl" /> */}
        
//         {/* Logo SVG */}
//         <motion.svg 
//           viewBox="0 0 110 60" 
//           className="relative z-10 w-20 h-20 filter drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]"
//           initial={{ opacity: 0, x: -10 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//         >
//           {/* Animated Dots */}
//           {dots.map((dot, i) => (
//             <motion.circle 
//               key={i} 
//               cx={dot.x} 
//               cy={dot.y} 
//               r={dot.r} 
//               className="fill-zinc-300"
//               animate={{ opacity: [0.4, 1, 0.4] }}
//               transition={{ 
//                 duration: 2.5, 
//                 delay: i * 0.1, 
//                 repeat: Infinity, 
//                 ease: "easeInOut" 
//               }}
//             />
//           ))}
          
//           {/* Play Button Shape */}
//        {/* Play Button Shape - Shifted Right for more gap */}
// <path 
//   d="M64 8.5C60.5 6.4 56 8.9 56 13V47C56 51.1 60.5 53.6 64 51.5L93.5 34.5C97 32.4 97 27.6 93.5 25.5L64 8.5Z" 
//   className="fill-white"
// />
//         </motion.svg>
//       </div>

//       {/* Animated Text "Oqlous" */}
//       <motion.span
//         initial={{ opacity: 0, x: -20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ 
//           duration: 0.8, 
//           delay: 0.3, 
//           ease: [0.22, 1, 0.36, 1] 
//         }}
//         className="text-4xl font-semibold tracking-tight text-white select-none"
//       >
//         Oqlous
//       </motion.span>
//     </div>
//   );
// };

// export default OqlousLogo;


import React from 'react';
import { motion } from 'framer-motion';

const OqlousCTA = () => {
  return (
    <div className="flex items-center justify-center p-12 rounded-xl">
      {/* Animated Call to Action Text */}
      <motion.span
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.8, 
          delay: 0.2, 
          ease: [0.22, 1, 0.36, 1] 
        }}
        className="text-4xl font-bold tracking-tight transition-colors cursor-pointer select-none text-zinc-400 hover:text-blue-400"
      >
    How can I help you today?
      </motion.span>
    </div>
  );
};

export default OqlousCTA;